import { useEffect } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import MobileEmergencyBar from '../../components/MobileEmergencyBar';
import ServiceHero from './components/ServiceHero';
import EmergencyGuide from './components/EmergencyGuide';
import ServiceCategories from './components/ServiceCategories';
import ProblemDiagnosisTool from './components/ProblemDiagnosisTool';
import TestimonialsSection from './components/TestimonialsSection';
import BeforeAfterGallery from './components/BeforeAfterGallery';
import ServiceAreaMap from './components/ServiceAreaMap';
import PricingTransparency from './components/PricingTransparency';
import AvailabilityIndicator from './components/AvailabilityIndicator';

const PlumbingServices = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleEmergencyClick = () => {
    window.location.href = 'tel:0827935785';
  };

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      
      <main className="flex-1 pt-16">
        <ServiceHero onEmergencyClick={handleEmergencyClick} />
        <EmergencyGuide onEmergencyClick={handleEmergencyClick} />
        <ServiceCategories />
        <ProblemDiagnosisTool onEmergencyClick={handleEmergencyClick} />
        {/* <AvailabilityIndicator onEmergencyClick={handleEmergencyClick} /> */}
        {/* <TestimonialsSection /> */}
        <BeforeAfterGallery />
        <PricingTransparency />
        <ServiceAreaMap />
      </main>

      <Footer />
      <MobileEmergencyBar />
    </div>
  );
};

export default PlumbingServices;